import APIKit from "../Allapis/Apikit/apikit";

export const loginServer = async (body) => {
  try {
    const url = `/users/webLogin`;
    const result = await APIKit.post(url, body);
    StorageToken(result.data.result);
    console.log({resikgkguu:result})
    return result;
  } catch (e) {
    return e.response ? e.response : e;
  }
};

export const StorageToken = async (token) => {
  await localStorage.setItem("token", token.accessToken);
  if (token.id) await localStorage.setItem("Id", token.id);
  if (token.email) await localStorage.setItem("email", token.email);
  if (token.otp) await localStorage.setItem("Otp", token.otp);
  if(token.name) await localStorage.setItem("Name" , token.name);
  
};
